jQuery(document).ready(function($){
    if($('.inline-btns').length) {
        $('.inline-btns').each(function(){
            let btnSize = 0;
            // let btnContainer = $(this).closest('div').width();
            let btnCount = $(this).find('a.btn').length;
            $(this).find('a.btn').each(function(){
                if($(this).innerWidth() > btnSize) {
                    btnSize = $(this).innerWidth();
                }
            });

            // if(btnContainer > ((btnSize * btnCount) + 20)) {
                $(this).find('a.btn').each(function(){
                    $(this).css('min-width', btnSize + 'px');
                });
            // }
        });
    }
});